export enum EServiceStatus {
  SUSPENDED = 'SUSPENDED',
  DEACTIVATED = 'DEACTIVATED',
  PUBLISHED = 'PUBLISHED',
}
